import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const HD = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M2.844 6.416a3.25 3.25 0 0 1 3.25-3.25h12a3.25 3.25 0 0 1 3.25 3.25v12a3.25 3.25 0 0 1-3.25 3.25h-12a3.25 3.25 0 0 1-3.25-3.25z'
          stroke='currentColor'
          strokeWidth='1.5'
        />
        <path
          d='M5.855 15.916q-.37 0-.566-.203t-.195-.571V9.69q0-.775.761-.775.752 0 .752.775v2.052h3.201V9.691q0-.775.752-.775.761 0 .761.775v5.45q0 .369-.195.572t-.566.203q-.36 0-.556-.203t-.196-.571v-2.15H6.607v2.15q0 .774-.752.774'
          fill='currentColor'
        />
        <path
          d='M13.5 15.829q-.79 0-.79-.784V9.787q0-.784.79-.784h1.904q1.758 0 2.723.89.967.882.967 2.518t-.967 2.527-2.723.89zm.723-1.23h1.093q2.196 0 2.196-2.188 0-2.178-2.196-2.178h-1.093z'
          fill='currentColor'
        />
      </>
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.094 2.416a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4v-12a4 4 0 0 0-4-4zm-.805 13.297q.195.203.566.203.752 0 .752-.774v-2.15h3.201v2.15q0 .367.196.57.195.204.556.204.37 0 .566-.203t.195-.571V9.69q0-.775-.761-.775-.752 0-.752.775v2.052H6.607V9.691q0-.775-.752-.775-.76 0-.761.775v5.45q0 .369.195.572m7.421-.668q0 .784.79.784h1.904q1.758 0 2.723-.89.967-.892.967-2.528t-.967-2.517q-.966-.89-2.723-.89h-1.903q-.79 0-.791.783zm2.606-.446h-1.093v-4.366h1.093q2.196 0 2.196 2.178 0 2.188-2.196 2.188'
        fill='currentColor'
      />
    )}
  </IconBase>
);
